import client from 'core/axios';

export const populateNotifications = ({ results, count }) => ({
  type: 'NOTIFICATIONS/MERGE_NOTIFICATIONS',
  results,
  count,
});

export const populateLatestNotifications = ({ results, count }) => ({
  type: 'NOTIFICATIONS/PRE_MERGE_NOTIFICATIONS',
  results,
  count,
});

export const populateUnseenCount = ({
  unseenNotificationsCount,
  unseenMessageCenterCount,
}) => ({
  type: 'NOTIFICATIONS/UPDATE_UNSEEN_COUNT',
  count: unseenNotificationsCount,
  messageCount: unseenMessageCenterCount,
});

export const populateUnreadCount = ({ count }) => ({
  type: 'NOTIFICATIONS/UPDATE_UNREAD_COUNT',
  count,
});

export const populateReadNotification = payload => ({
  type: 'NOTIFICATIONS/MARK_NOTIFICATION_READ',
  payload,
});

export const populateAllReadNotification = () => ({
  type: 'NOTIFICATIONS/MARK_ALL_NOTIFICATION_READ',
});

export const getNotifications = (params, latest = false) => async dispatch => {
  try {
    const path = `v1/notifications/notification/`;
    const { status, data } = await client.get(path, {
      params,
    });
    if (status === 200) {
      if (!latest) {
        return dispatch(populateNotifications(data));
      }
      return dispatch(populateLatestNotifications(data));
    }
  } catch (e) {
    console.warn('could not get notifications', e);
  }

  return null;
};

export const getUnseenNotificationsCount = () => async (dispatch, getState) => {
  try {
    const { status, data } = await client.get(`v1/notifications/seen/`);
    if (status === 200) {
      const { unseenNotificationsCount, unseenMessageCenterCount } = data;
      const { notifications } = getState();
      const notificationsCountChanged =
        unseenNotificationsCount !== notifications.unseenCount;
      const messageCenterCountChanged =
        unseenMessageCenterCount !== notifications.unseenMessageCenterCount;

      if (notificationsCountChanged || messageCenterCountChanged) {
        dispatch(populateUnseenCount(data));
      }

      return data;
    }
  } catch (e) {
    console.warn('could not get unseen count', e);
  }

  return null;
};

export const markAllNotificationSeen = () => async dispatch => {
  try {
    const { status, data } = await client.post(`v1/notifications/seen/`);
    if (status === 200) return dispatch(populateUnseenCount(data));
  } catch (e) {
    console.warn('could not mark all seen', e);
  }

  return null;
};

export const getUnreadNotificationsCount = () => async dispatch => {
  try {
    const { data } = await client.get(`v1/notifications/notification/`, {
      params: {
        limit: 1,
        read: false,
      },
    });
    dispatch(populateUnreadCount(data));
  } catch (e) {
    console.warn('could not get unread count', e);
  }

  return null;
};

export const markNotificationRead = notificationId => async dispatch => {
  try {
    const { status, data } = await client.patch(
      `v1/notifications/${notificationId}`,
      {
        read: true,
      },
    );

    if (status === 200) {
      await dispatch(getUnreadNotificationsCount());
      dispatch(populateReadNotification(data));
      return data;
    }
  } catch (e) {
    console.warn('could not update notifications', e);
  }

  return null;
};

export const markAllNotificationRead = () => async dispatch => {
  try {
    const { status } = await client.patch(
      `v1/notifications/mark-all-read`,
      {
        read: true,
      },
    );

    if (status === 200) {
      await dispatch(getUnreadNotificationsCount());
      return dispatch(populateAllReadNotification());
    }
  } catch (e) {
    console.warn('could not update notifications', e);
  }

  return null;
};
